<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-basket" />
        Brand icons
      </c-card-header>
      <c-card-body>
        <c-row class="text-center">
          <template v-for="(brand, brandName) in $options.brands">
            <c-col :key="brandName" class="mb-5" col="3" sm="2">
              <c-icon :height="42" :content="brand" />
              <div>{{ toKebabCase(brandName) }}</div>
            </c-col>
          </template>
        </c-row>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
import { brandSet as brands } from '@coreui/icons';

export default {
  name: 'Brands',
  brands,
  methods: {
    toKebabCase(str) {
      return str.replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
    },
  },
};
</script>
